let instance;

class FormListener {
	observeAttribute() {
		return window.od.events.subscribe(
			'state::change',
			this.updateAttribute.bind(this),
		);
	}

	updateAttribute(event) {
		if (event.target.id === this.senderId) {
			if (event.target.checked) {
				this.context.setAttribute(
					this.attributeName,
					this.attributeValueWhenChecked,
				);
			} else {
				switch (this.formId) {
					case 'billingForm':
						this.context.setAttribute(
							this.attributeName,
							this.attributeValueWhenUnchecked,
						);
						break;
					default:
						this.context.removeAttribute(this.attributeName);
				}
			}
		}
	}

	init() {
		const formParentNode = document.getElementById('addressForm');

		if (formParentNode) {
			this.formId = formParentNode.querySelector('form').getAttribute('id');
		}

		if (this.formId === 'billingForm') {
			this.attributeName = 'data-validate-specific-fields';
			this.attributeValueWhenChecked =
				'phone|paymentMethod|invoiceEmailAddress';
			this.attributeValueWhenUnchecked =
				'companyName|contactName|phone|address1|postalCode|town|paymentMethod|invoiceEmailAddress';
		} else {
			this.attributeName = 'data-validate-form';
			this.attributeValueWhenChecked = false;
		}

		this.senderId = 'sameAsAddressCheckBox';
		this.receiverId = this.formId;
		this.context = document.querySelector(`#${this.receiverId}`);
		if (this.context) {
			this.observeAttribute();
		}

		return this;
	}
}

export default function () {
	if (!instance) {
		instance = new FormListener();
	}

	return instance;
}
